import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 9,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.40002 9.40039L5.02502 6.02539L1.65002 9.40039L0.650024 8.40039L4.02502 5.02539L0.650024 1.65039L1.65002 0.650391L5.02502 4.02539L8.40002 0.650391L9.40002 1.65039L6.02502 5.02539L9.40002 8.40039L8.40002 9.40039Z",
		fill: "#E20909"
	})
});
export default SvgError;
